import { MediaDocument } from '../../media-document.model';

export class ContentDocumentEditorialBlogAdapter {
    static toContentDocument(document: any): MediaDocument {
        return new MediaDocument(document);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-editorial-blog.adapter.ts